// extracted by mini-css-extract-plugin
export default {"root":"Message_root__zN6LI"};